<template>
  <header v-if="userStore.isLoggedIn">
    <div class="header-left">
      <h1>
        <slot name="pageTitle"></slot>
        <div class="header-left--button">
          <slot name="pageButton"></slot>
        </div>
      </h1>
      <slot name="pageDescription"></slot>
    </div>
    <div class="header-right">
      <div class="header-user-menu">
        <Tooltip position="left">
          <template v-slot:text>
            <Button
              @click="launchTour"
              severity="tertiary"
              :rounded="true"
              aria-label="Launch self-guided tour"
            >
              <template #iconLeft><IconHelp /></template>
            </Button>
          </template>
          <template v-slot:tooltip> Launch self-guided tour </template>
        </Tooltip>

        <IconNotifications />
        <IconSettings
          class="header-icon"
          @click="router.push({ name: 'settings' })"
          v-if="userStore.isStaff"
        />

        <UserMenu position="bottom" data-testid="user-menu-button">
          <template #button>
            <div class="user-avatar">
              {{ userStore.getInitials() }}
            </div>
          </template>
        </UserMenu>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

import Button from '@/components/global/Button.vue';
import Tooltip from '@/components/global/Tooltip.vue';
import UserMenu from '@/components/global/UserMenu.vue';

import IconHelp from '@/icons/header/IconHelp.svg?component';
import IconNotifications from '@/icons/header/IconNotifications.svg?component';
import IconSettings from '@/icons/header/IconSettings.svg?component';

import { useUserStore } from '@/stores/user';
const userStore = useUserStore();

const router = useRouter();

const launchTour = () => {
  if (userStore.userData) {
    router.push({ name: 'overview', hash: '#tour' });
  }
};
</script>

<style lang="scss">
header {
  @include mixins.flex-center($horiz: space-between, $wrap: true);
  margin-bottom: variables.$sizing-lg;
}

.header-left {
  flex-grow: 1;
}

.header-left h1 {
  @include mixins.flex-center($horiz: flex-start);
  width: 100%;

  .header-left--button {
    margin-left: auto;
    margin-right: variables.$sizing-xs;
  }
}

.header-right {
  @include mixins.flex-center($horiz: flex-end);
}

.header-user-menu {
  @include mixins.flex-center($horiz: flex-end);
  column-gap: variables.$sizing-xs;
  flex-basis: 100%;
}

.mobile .header-user-menu {
  display: none;
}

.user-avatar {
  @include mixins.flex-center();
  background: variables.$primitives-color-secondary-500;
  border-radius: 50%;
  color: variables.$primitives-color-background-100;
  cursor: pointer;
  height: variables.$sizing-xl;
  width: variables.$sizing-xl;
}

.header-icon {
  cursor: pointer;
}
</style>
